const ArticleAuthorDecorator = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width={125}
    height={125}
    viewBox="0 0 125 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.6}
      d="M0.691406 32.1117C0.691406 14.9109 14.6355 0.966797 31.8363 0.966797H61.8884V63.2566H31.8363C14.6355 63.2566 0.691406 49.3126 0.691406 32.1117Z"
      fill="#A1C2C7"
    />
    <path
      d="M61.8867 62.1638L61.8867 44.9279C61.8867 20.6488 81.5688 0.966807 105.848 0.966806L124.177 0.966806L124.177 62.1638L61.8867 62.1638Z"
      fill="#FE5E44"
    />
    <path
      d="M62.9805 62.7109L62.9805 123.908L0.690648 123.908C0.69065 90.1098 28.0895 62.7109 61.8877 62.7109L62.9805 62.7109Z"
      fill="white"
    />
    <path
      d="M62.9805 93.3095C62.9805 76.4104 76.6799 62.7109 93.579 62.7109C110.478 62.7109 124.177 76.4104 124.177 93.3094V94.4022C124.177 111.301 110.478 125.001 93.579 125.001C76.6799 125.001 62.9805 111.301 62.9805 94.4022V93.3095Z"
      fill="#FFB040"
    />
  </svg>
);
export default ArticleAuthorDecorator;
